import moment from "moment-timezone";

export function getTimeZone() {
    return (window.__UpshowState && window.__UpshowState.settings && window.__UpshowState.settings.tz) || "UTC";
}

export function getNow(tz) {
    tz = tz || getTimeZone();
    return moment().tz(tz);
}

export function getLocalMoment(tz) {
    tz = tz || getTimeZone();
    return moment().tz(tz);
}

export function getFormattedTime(time, format, tz) {
    format = format || "hh:mm A";
    tz = tz || getTimeZone();
    if (!time) return "";
    return moment.tz(time, tz).format(format);
}

export function isEventLiveBySchedule(startTime, endTime, tz) {
    tz = tz || getTimeZone();
    if (!startTime || !endTime || !tz) return false;

    const now = getLocalMoment(tz);
    if (!now) return false;

    const startMoment = moment.tz(startTime, tz);
    const endMoment = moment.tz(endTime, tz);

    return now.isBetween(startMoment, endMoment, null, "[)");
}

// Returns true only if `time` is in the future AND before midnight today (device tz).
// Use this for SCHEDULED events to exclude stale entries the server hasn't transitioned yet.
export function isStartTimeUpcoming(time) {
    if (!time) return false;
    const tz = getTimeZone();
    const t = moment.tz(time, tz);
    const now = getNow(tz);
    return t.isSameOrAfter(now) && t.isBefore(now.endOf("day"));
}

export function getWeekdayLabel(eventTime, tz) {
    tz = tz || getTimeZone();
    if (!eventTime || !tz) return null;

    const start = moment.tz(eventTime, tz);
    const today = getLocalMoment(tz);
    if (!today) return null;

    if (start.isSame(today, "day")) {
        return "TODAY";
    } else if (start.isoWeek() === today.isoWeek()) {
        return start.format("dddd").toUpperCase();
    } else {
        return start.format("ddd MM/DD").toUpperCase();
    }
}
